import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { StateModel } from '../../models/state-model';
import { CityModel } from '../../models/city-model';
import { InvoiceUserModel, userOption, userResult, RouteCodeModel } from '../../models/orders/order-list-model';
import { Dropdown, DropdownChangeEvent, DropdownFilterEvent } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { reportTypes, statusTypes } from '../../services/order/order-list.-mock';
import UserAddressService from '../../services/useraddress/useraddress.service';
import orderServices from '../../services/orders/orderservice';
import routeCodeServices from '../../services/route-codes/routecode.service';
import { InputSwitch, InputSwitchChangeEvent } from 'primereact/inputswitch';

interface SearchPanelProps {
  onSearch: (query: string, openOrder: boolean) => void;
  setLoading: (loading: boolean) => void;
}

const InvoicesSearch: React.FC<SearchPanelProps> = ({ onSearch, setLoading }) => {

    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    const [startDate, setStartDate] = useState<any>(yesterday);
    const [endDate, setEndDate] = useState<any>(today);
    const [cities, setCities] = useState<StateModel[]>([]);
    const [states, setStates] = useState<CityModel[]>([]);
    const [invoiceUsers, setInvoiceUsers] = useState<InvoiceUserModel[]>([]);
    const [voucherNo, setVoucherNo] = useState("");
    const [voucherType, setVoucherType] = useState("Order");
    const [searchStatus, setSearchStatus] = useState("");
    const [searchInvoiceBy, setSearchInvoiceBy] = useState("");
    const [searchState, setSearchState] = useState("");
    const [searchCity, setSearchCity] = useState("");
    const [selectedUser, setSelectedUser] = useState<any>();
    const blankUserDetail: userOption[] = [{ userID: 0, name: '', primaryContactNbr: ''},];
    const [orderUsers, setOrderUsers] = useState<userOption[]>(blankUserDetail);
    const [orderUser, setOrderUser] = useState<userResult[]>([]);
    const [routeCodes, setRouteCodes] = useState<RouteCodeModel[]>([]);
    const [searchRouteCode, setSearchRouteCode] = useState("");
    const [openOrders, setOpenOrders] = useState<boolean>(true);

    const FetchStates = (countryId: number) => {
        UserAddressService.getStates(countryId).then(r =>  setStates(r));
    }
    
    const FetchCities = (stateId: number) => {
        UserAddressService.getCities(stateId).then(r =>  setCities(r));
    }

    const FetchInvoiceUsers = () => {
        UserAddressService.getInvoiceUsers().then(r =>  setInvoiceUsers(r));
    }

    const FetchRouteCodes = () => {
        routeCodeServices.getRouteCodes().then(r =>  setRouteCodes(r));
    }

    const handleDropdownChange = (e: DropdownChangeEvent) => {
        setSelectedUser(e.value);
    }

    const handleDropdownFilter = (e: DropdownFilterEvent) => {
        if(e.filter.length>2){
            orderServices.getOrderUsers(e.filter).then((response: userOption[]) => {
                if(response.length>0){
                    setOrderUsers(response)
                }        
            })
        }
    }

    useEffect(() => {
        FetchStates(1);
        FetchInvoiceUsers();
        FetchRouteCodes();
        const searchFilter: string = "?$filter=createdDate ge " + startDate.toISOString().substr(0, 10) + " and createdDate le " + endDate.toISOString().substr(0, 10);
        onSearch(searchFilter, true);
    }, []);

    useEffect(() => {              
        setOrderUser(orderUsers.map((user) => ({
            userID: user.userID,
            detail: `${user.name}, ${user.primaryContactNbr}`,
        })));
    }, [orderUsers]);

    const handleSearch = () => {
        setLoading(true); 
        let searchFilter: string = "?$filter=";
        let searchFound: number = 0;
        if(startDate && endDate) {
            searchFound = 1;
            const startDt = startDate.toLocaleDateString('pt-br').split( '/' ).reverse( ).join( '-' );
            const endDt = endDate.toLocaleDateString('pt-br').split( '/' ).reverse( ).join( '-' );
            if(voucherType==='Order'){
                searchFilter = searchFilter + "createdDate ge " + startDt + " and createdDate le " + endDt;
            }
            else {
                searchFilter = searchFilter + "orderInvoice/any(oi:  oi/invoicedDate ge " + startDt + " and oi/invoicedDate le " + endDt + ")";
            }
        }
        if(searchState && searchState.length > 0) {
            if(searchFound === 1) {
                searchFilter = searchFilter + " and ";
            }
            else{
                searchFound = 1;
            }
            if(searchCity && searchCity.length > 0) {
                searchFilter = searchFilter + "cityID in (" + searchCity + ")";
            }
            else {
                searchFilter = searchFilter + "stateID in (" + searchState + ")";
            }
        }
        if(searchInvoiceBy && searchInvoiceBy.length > 0) {
            if(searchFound === 1) {
                searchFilter = searchFilter + " and ";
            }
            else{
                searchFound = 1;
            }
            searchFilter = searchFilter + "orderInvoice/any(oi: oi/invoicedBy eq " + searchInvoiceBy + ")";
        }
        if(searchStatus && searchStatus.length > 0) {
            if(searchFound === 1) {
                searchFilter = searchFilter + " and ";
            }
            else{
                searchFound = 1;
            }
            searchFilter = searchFilter + "orderStatusID in (" + searchStatus + ")";
        }
        if(voucherNo) {
            if(searchFound === 1) {
                searchFilter = searchFilter + " and ";
            }
            else{
                searchFound = 1;
            }
            if(voucherType==='Order'){
                searchFilter = searchFilter + "orderID in (" + voucherNo + ")";
            }
            else{
                searchFilter = searchFilter + "orderInvoice/any(oi: oi/invoiceNo  in (" + voucherNo + "))";
            }            
        }
        if(selectedUser) {
            if(searchFound === 1) {
                searchFilter = searchFilter + " and ";
            }
            else{
                searchFound = 1;
            }
            searchFilter = searchFilter + "userID eq " + selectedUser;
        }

        onSearch(searchFilter, openOrders);        
    }    

    const resetSearchFields = () => {
        setOrderUsers(blankUserDetail);
        setSelectedUser(null);
        setSearchState("");
        setSearchCity("");
        setVoucherNo("");
        setVoucherType("Order");
        setSearchStatus("");
        setSearchInvoiceBy("");
        setStartDate("");
        setEndDate("");
        setSearchRouteCode("");
    }

    return (
        <div className="col card border-noround p-2">
            <div className='grid'>
                <div className="col-12 sm:col-6 lg:col-3  font-bold text-white border-round">
                    <Dropdown
                        id="SearchUser"
                        name="SearchUser"                                                      
                        options={orderUser} 
                        optionLabel="detail"
                        optionValue="userID"
                        value={selectedUser}
                        onChange={handleDropdownChange}
                        onFilter={handleDropdownFilter} filter
                        placeholder="Search for User/Mobile" style={{ width: "100%" }}
                    />
                </div>
                <div className="col-12 sm:col-6 lg:col-3  font-bold text-white border-round">
                    <MultiSelect
                        id="status"
                        name="status"
                        options={statusTypes}
                        optionLabel="name"
                        optionValue="id"
                        value={searchStatus}
                        display="chip"
                        onChange={(e) => setSearchStatus(e.target.value)}
                        placeholder="Choose Status" style={{ width: "100%" }}
                    />
                </div>
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round">
                    <MultiSelect
                        id="RouteCode"
                        name="RouteCode"
                        options={routeCodes}
                        optionLabel="name"
                        optionValue="routeCodeID"
                        value={searchRouteCode}
                        display="chip"
                        onChange={(e) => setSearchRouteCode(e.target.value)}
                        placeholder="Choose Route Code" style={{ width: "100%" }}
                    />
                </div>
                <div className="col-12 sm:col-6 lg:col-3 border-round pl-8">                                          
                    <div style={{float: "left"}}><InputSwitch inputId="input-metakey" checked={openOrders} onChange={(e: InputSwitchChangeEvent) => setOpenOrders(e.value!)} /></div>                        
                    <div className='ml-1' style={{float: "left"}}><label htmlFor="input-metakey">Invoiced Orders</label></div> 
                </div>
            </div>
            <div className="grid">                       
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round">
                    <MultiSelect
                        id="State"
                        name="State"
                        options={states}
                        optionLabel="name"
                        optionValue="stateID"
                        value={searchState}
                        display="chip"
                        onChange={(e) => {setSearchState(e.target.value); FetchCities(e.target.value);}}
                        placeholder="Choose State" style={{ width: "100%" }}
                    />
                </div>
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round">
                    <MultiSelect
                        id="city"
                        name="city"
                        options={cities}
                        optionLabel="name"
                        optionValue="cityID"
                        value={searchCity}
                        display="chip"
                        onChange={(e) => setSearchCity(e.target.value)}
                        placeholder="Choose City" style={{ width: "100%" }}
                    />
                </div>
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round">
                    <MultiSelect
                        id="invoiceBy"
                        name="invoiceBy"
                        options={invoiceUsers}
                        optionLabel="name"
                        optionValue="userID"
                        value={searchInvoiceBy}
                        display="chip"
                        onChange={(e) => setSearchInvoiceBy(e.target.value)}
                        placeholder="Invoice By" style={{ width: "100%" }}
                    />
                </div>
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round pl-8 pr-8">
                    <Button className=" text-black border-round" style={{ width: "100%" }} onClick={handleSearch} severity="success">Filter</Button>
                </div>
            </div>
            <div className="grid">
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round">
                    <Dropdown
                        id="reportType"
                        name="reportType"
                        options={reportTypes}
                        optionLabel="name"
                        optionValue="name"
                        value={voucherType}
                        onChange={(e) => setVoucherType(e.target.value)}
                        placeholder="Report Type" style={{ width: "100%" }}
                    />
                </div>
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round">
                    <InputText
                        id="OrderNo"
                        name="OrderNo"
                        value={voucherNo}
                        type="number"
                        onChange={(e) => setVoucherNo(e.target.value)}
                        placeholder={voucherType + "#"} style={{ width: "100%" }}
                    />
                </div>                        
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round">
                    <Calendar value={startDate}  onChange={(e) => setStartDate(e.value)} 
                    dateFormat="dd/mm/yy" style={{ width: "50%" }} 
                    placeholder="start date"/>
                    <Calendar value={endDate}  onChange={(e) => setEndDate(e.value)} 
                    dateFormat="dd/mm/yy" style={{ width: "50%" }} 
                    placeholder="end date"/>
                </div>
                <div className="col-12 sm:col-6 lg:col-3 font-bold text-white border-round pl-8 pr-8">
                    <Button className="text-black border-round" style={{ width: "100%"}} onClick={resetSearchFields} severity="secondary" text raised>Reset</Button>
                </div>
            </div>
        </div>
    );
};
export default InvoicesSearch;